export const LINKS = {
  gofundme:
    "https://www.gofundme.com/f/haven-for-tails-helping-local-animal-shelters",
  member:
    "https://docs.google.com/forms/d/e/1FAIpQLSekyZWbxtjmBldE_zUdfwR8YEoZ5Ui8gfOlWz7OwjZFknsU7g/viewform",
  marketing:
    "https://docs.google.com/forms/d/e/1FAIpQLSePBRqSR6r_HmgD7mJr60xHBgIDLrvXn75ZZJrlfKZN3u1zeA/viewform",
  paws:
    "https://docs.google.com/forms/d/e/1FAIpQLSeAkviAvwHEegzKiQGsRTTROCiTHB0sbBq0Ykw7OQ64cH-Osw/viewform",
  instagram: "https://instagram.com/haven_for_tails",
  email: "info.havenfortails23@gmail.com",
};

export const IMAGES = {
  logo: "https://customer-assets-rejwkqb3.emergentagent.net/job_paws-advocacy/artifacts/664zpy25_havenfortails.jpg",
  hero: "https://customer-assets-rejwkqb3.emergentagent.net/job_paws-advocacy/artifacts/68qtbw42__.jpeg",
  cat: "https://images.unsplash.com/photo-1642761677488-fafe59fa6f85?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwyfHxyZXNjdWUlMjBjYXQlMjBsb29raW5nJTIwd2lzZXxlbnwwfHx8fDE3ODUwMjQ3OTl8MA&ixlib=rb-4.1.0&q=85",
  aboutCat: "https://customer-assets-rejwkqb3.emergentagent.net/job_paws-advocacy/artifacts/78g20m9z_%F0%9F%AB%B6%F0%9F%90%B1.jpeg",
  work: "https://customer-assets-rejwkqb3.emergentagent.net/job_paws-advocacy/artifacts/r8w4e4po_Screenshot%202026-07-25%20at%2010.50.19%E2%80%AFPM.png",
  ashley:
    "https://customer-assets-rejwkqb3.emergentagent.net/job_paws-advocacy/artifacts/4xcf46e1_F6A51A6B-84BC-41E2-88CA-5987711B3FAA.JPG",
  samantha:
    "https://customer-assets-rejwkqb3.emergentagent.net/job_paws-advocacy/artifacts/h1slf7j9_IMG_5193.webp",
};

export const NAV = [
  { label: "About", href: "#about" },
  { label: "Our Work", href: "#work" },
  { label: "Campaigns", href: "#campaigns" },
  { label: "Get Involved", href: "#involved" },
  { label: "Officers", href: "#officers" },
  { label: "Contact", href: "#contact" },
];

export const WORK = [
  {
    n: "01",
    title: "Support Shelters",
    text: "We back local animal shelters with donations, supplies, and hands-on volunteer help so every animal has a warm place to heal.",
  },
  {
    n: "02",
    title: "Educate Others",
    text: "We spread awareness about animal welfare, adoption, and rescue — because kindness grows when knowledge does.",
  },
  {
    n: "03",
    title: "Inspire Youth",
    text: "We prove young people can be powerful change-makers, rallying students into advocacy, service, and everyday compassion.",
  },
];

export const TIMELINE = [
  {
    date: "05/22/2025",
    title: "Creation of Haven for Tails",
    text: "Haven for Tails was officially founded with the mission of bringing hope, comfort, and support to shelter animals through education, volunteerism, advocacy, and community engagement. What started as a single idea has grown into a youth-led nonprofit dedicated to empowering volunteers, partnering with animal shelters, and creating initiatives that improve the lives of homeless animals while inspiring compassion in communities around the world.",
  },
  {
    date: "08/25/2025",
    title: "Donation Drive with BossyPaws Animal Shelter",
    text: "Haven for Tails launched a donation drive, earning $155 in funds, food, and toys for the animals in need at BossyPaws.",
  },
  {
    date: "08/23/2026",
    title: "Paws Up Pet Rescue Donation Drive",
    text: "We are selling sunglasses to fund the medical fees for the cats and dogs at Paws Up Pet Rescue.",
  },
];

export const OFFICERS = [
  {
    name: "Ashley Ahn",
    role: "Founder",
    img: IMAGES.ashley,
    bio: "Hi! My name is Ashley, and I'm a high school junior and the founder of Haven for Tails. I've always had a deep love for animals, and over the years, I've become more aware of the heartbreaking realities many of them face — abandonment, abuse, overcrowded shelters, and a lack of resources. I started Haven for Tails to make a difference. I wanted to do something — not someday, but now. Even as a teenager, I realized I could rally others, raise awareness, and make a real impact for animals in need. Through this organization, I hope to support local shelters, provide supplies for animals, educate others about adoption, rescue, and kindness, and show that young people can be powerful change-makers. Outside of this, I love to draw, sing, and ice skate. I also have a pet cat named Luna! I'm incredibly excited to grow Haven for Tails and connect with others who care about giving animals the love and safety they deserve. Thanks for being here — you're part of this journey, too.",
  },
  {
    name: "Samantha Lin",
    role: "Co-Founder",
    img: IMAGES.samantha,
    bio: "Hey! I'm Samantha, a high school junior. I've always had a soft spot for animals, and spending time with them is one of the things that makes me happiest. Whether it's helping out, learning more about how to care for them, or just being around them, it's something that's really close to my heart. Outside of this, I'm in multiple volunteering clubs and I tutor kids online after school. I really enjoy helping people and I hope joining this nonprofit will really make a difference!",
  },
];
